document.querySelectorAll(".desktop_header nav .list-menu li details").forEach(details => {
    details.addEventListener("mouseenter", () => {
        details.setAttribute("open", "");
    });

    details.addEventListener("mouseleave", (event) => {
        // Only close if the mouse is completely leaving the <details> element
        if (!details.contains(event.relatedTarget)) {
            details.removeAttribute("open");
        }
    });
});
